import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  editDialog: {
    width: '90%',
    minHeight: 500,
    maxHeight: '90%',
  },
  notificationDialog: {
    width: 376,
  },
  notificationTitle: {
    heigh: 116,
    background: theme.palette.error.main,
    lineHeight: 116,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
